import { ApiUrls } from "../../../utils/apiUrls";
import authAxios from "../../../services/axiosInstance";
import axios from "axios";
export const getAllAbsentList = (
  per_page,
  page_no,
  order_by,
  order_type,
  person_name,
  person_number,
  department,
  selectedDate,
  type,
  download
) => {
  return authAxios
    .get(ApiUrls.Attendance.GET_ALL_STAFF_ABSENT, {
      params: {
        per_page,
        page_no,
        order_by,
        order_type,
        person_name,
        person_number,
        department,
        selectedDate,
        type,
        download
      },
    })
    .then(({ data }) => data)
    .catch((response) => response);
};
